module.exports = __webpack_public_path__ + "static/media/Ex5-S3.e79c73bc.PNG";